import {
  ISettingsForm,
  ISettingsResponse,
} from 'services/settings/application/types';
import { MONTH } from 'services/types';

export const applicationSettingsQueryToForm = (
  query: ISettingsResponse
): ISettingsForm => ({
  periodType: query.settlementPeriodType.id,
  settlementStartMonth: query.settlementStartMonth ?? MONTH.unknown,
  isrcPrefix: query.isrcPrefix ?? '',
  phoneNumberPrefix: query.phoneNumberPrefix,
  defaultApplicationLanguage: query.defaultApplicationLanguage,
  showOnlyVerifiedArtists: query.showOnlyVerifiedArtists,
  showOnlyVerifiedTracks: query.showOnlyVerifiedTracks,
  showOnlyVerifiedMerch: query.showOnlyVerifiedMerch,
  showNotActiveSalesChannels: query.showNotActiveSalesChannels,
  allowContractsWithSameLabel: query.allowContractsWithSameLabel,
  documentsConfiguration: {
    settlementShortcut: query.settlementShortcut,
    labelReportShortcut: query.labelReportShortcut,
    advanceRepaymentShortcut: query.advanceRepaymentShortcut,
    advanceFinalShortcut: query.advanceFinalShortcut,
    advanceProposalShortcut: query.advanceProposalShortcut,
    costRepaymentShortcut: query.costRepaymentShortcut,
    ownerReportShortcut: query.ownerReportShortcut,
    advanceProposalNumerationType: query.advanceProposalNumerationType.id,
    advanceRepaymentNumerationType: query.advanceRepaymentNumerationType.id,
    advanceFinalNumerationType: query.advanceFinalNumerationType.id,
    settlementNumerationType: query.settlementNumerationType.id,
    labelReportNumerationType: query.labelReportNumerationType.id,
    costRepaymentNumerationType: query.costRepaymentNumerationType.id,
    ownerReportNumerationType: query.ownerReportNumerationType.id,
  },
  artistDescriptionMaxLength: query.artistDescriptionMaxLength,
  isrcStartNumber: query.isrcStartNumber ?? 0,
  extensionContract: query.extensionContract,
  expirationRangeInMonths: query.expirationRangeInMonths,
  defaultThemeMode: query.defaultThemeMode,
  canChangeThemeMode: query.canChangeThemeMode,
  currentTheme: query.currentTheme,
  ...query.emailSendConfiguration,
});
